import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { isDefined } from "@perxis-auto/shared";
import { OverlayView } from "@react-google-maps/api";
import classnames from "../../../../utils/classnames.js";
const Balloon = ({ pins, selected, balloonContent, enableBalloon }) => {
  const hiddenBalloon = !isDefined(selected) || !balloonContent || !enableBalloon;
  if (hiddenBalloon) {
    return null;
  }
  const currentPin = pins.find((m) => m.id === selected);
  return /* @__PURE__ */ jsx(
    OverlayView,
    {
      mapPaneName: "floatPane",
      position: {
        lat: (currentPin == null ? void 0 : currentPin.latitude) ?? 0,
        lng: (currentPin == null ? void 0 : currentPin.longitude) ?? 0
      },
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: classnames("perxis-auto-map__balloon"),
          style: { userSelect: "text", cursor: "default" },
          onClick: (e) => e.stopPropagation(),
          "aria-hidden": "true",
          children: balloonContent
        }
      )
    }
  );
};
const Balloon$1 = memo(Balloon);
export {
  Balloon$1 as default
};
//# sourceMappingURL=Balloon.js.map
